export function initRelatedArticlesLoadMore(): void {
  const sections = document.querySelectorAll<HTMLElement>('[data-related-articles]')
  sections.forEach(initSection)
}

function initSection(section: HTMLElement): void {
  const btn = section.querySelector<HTMLButtonElement>('[data-related-load-more]')
  if (!btn) {return}

  const wrapper = section.querySelector<HTMLElement>('[data-related-load-more-wrapper]')
  const hiddenItems = Array.from(
    section.querySelectorAll<HTMLElement>('[data-related-item].hidden')
  )
  const perPage = parseInt(btn.dataset.perPage ?? '4', 10)
  let revealed = 0

  btn.addEventListener('click', () => {
    const toShow = hiddenItems.slice(revealed, revealed + perPage)
    toShow.forEach((item) => item.classList.remove('hidden'))
    revealed += toShow.length

    if (revealed >= hiddenItems.length) {
      wrapper?.remove()
    }
  })
}
